type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/**
 * Hängt die Längen-Abweichung (in Tagen, vorzeichenbehaftet) an das Karten-Label
 * an – z. B. `Mathe (+5 Tage)`. Bei `0` bleibt das Label unverändert.
 */
/**
 * Vorzeichenbehaftete Abweichung als Text, z. B. `+5 Tage` / `−3 Tage`. Leer bei `0`.
 */
export const formatDeviationDays = (deviationDays: number, t: TranslateFn): string => {
  if (deviationDays === 0) return '';
  const sign = deviationDays > 0 ? '+' : '−';
  return `${sign}${t('pinboard.actions.lengthDeviationDays', { count: Math.abs(deviationDays) })}`;
};

export const formatCardTitleWithDeviation = (
  label: string | undefined,
  deviationDays: number,
  t: TranslateFn,
): string => {
  const safeLabel = label ?? '';
  const deviation = formatDeviationDays(deviationDays, t);
  return deviation ? `${safeLabel} (${deviation})` : safeLabel;
};
